import {mapState} from 'vuex'
import _sortBy from 'lodash/sortBy'

export default {
  computed: {
    ...mapState(['eventsdata', 'candidates', 'constituencies', 'parties'])
  },
  methods: {
    getEventsBy (filter) {
      // filter {date, category, categeryvalue}
      var events = []
      if (this.eventsdata) {
        this.eventsdata.forEach((el, i) => {
          const start = (new Date(el.start)).setHours(0, 0, 0, 0)
          const end = (new Date(el.end)).setHours(0, 0, 0, 0)
          const dateSelected = (new Date(filter.date)).setHours(0, 0, 0, 0)
          var prioritystr = el.noun

          if (start <= dateSelected && end && end >= dateSelected) {
            if (filter.categoryvalue) {
              var optionKey = filter.categoryvalue.toLowerCase()
              if (filter.category === 'party' && this.parties[optionKey] && this.parties[optionKey].includes(el.index)) {
                events.push(el)
              } else if (filter.category === 'constituency') {
                if (this.constituencies[optionKey] && this.constituencies[optionKey].includes(el.index)) {
                  events.push(el)
                } else if (!el.constituency) {
                  events.push(el)
                }
              } else if (this.candidates[optionKey] && this.candidates[optionKey].includes(el.index)) {
                events.push(el)
              }
            } else {
              events.push(el)
            }
            // set another priority for today. past event will be last
            events[events.length - 1].prioritystr = prioritystr
            if (el.end && new Date() > new Date(el.end)) {
              events[events.length - 1].prioritystr = prioritystr + '1'
            }
          }
        })
      }
      events = _sortBy(events, ['noun', 'prioritystr', 'start'])
      events.date = filter.date
      this.$store.commit('pushResponse', {
        eventsondate: events
      })
      return events
    }
  }
}
